import { Schema, Smtp } from "../../../../../@types";
import Name from "../../../../../../search/schema/components/Name";
import { enums } from "../../../../../../../shim/jsbridge";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const smtp: Schema<Smtp> = {
  fields: [
    {
      name: "dst",
      displayTitle: "Destination",
      sortable: true,
      component: (d: Smtp) => (
        <Name
          data={{
            file_name: d.dst,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "raw",
      displayTitle: "Raw data",
      sortable: true,
      component: (d: Smtp) => <>{d.raw}</>
    }
  ]
};
